<!-- Success Banner -->
<div *ngIf="isSuccess"
  class="alert-toast alert-toast-success"
  role="alert">
  <div class="flex items-center gap-2.5">
    <svg class="shrink-0 size-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM8 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9z" fill="#15803d"/>
    </svg>
    <span class="text-xs font-medium font-montserrat text-gray-800 break-words" [innerHTML]="message"></span>
  </div>
  <svg (click)="handleClose()" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"
    class="shrink-0 size-3.5 cursor-pointer opacity-50 hover:opacity-100 transition-opacity">
    <path
      d="M7.46683 22.1666L5.8335 20.5333L12.3668 14L5.8335 7.46665L7.46683 5.83331L14.0002 12.3666L20.5335 5.83331L22.1668 7.46665L15.6335 14L22.1668 20.5333L20.5335 22.1666L14.0002 15.6333L7.46683 22.1666Z"
      fill="#6b7280"></path>
  </svg>
</div>

<!-- Error Banner -->
<div *ngIf="isError"
  class="alert-toast alert-toast-error"
  role="alert">
  <div class="flex items-center gap-2.5">
    <svg class="shrink-0 size-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z" fill="#dc2626"/>
    </svg>
    <span class="text-xs font-medium font-montserrat text-gray-800 break-words" [innerHTML]="message"></span>
  </div>
  <svg (click)="handleClose()" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"
    class="shrink-0 size-3.5 cursor-pointer opacity-50 hover:opacity-100 transition-opacity">
    <path
      d="M7.46683 22.1666L5.8335 20.5333L12.3668 14L5.8335 7.46665L7.46683 5.83331L14.0002 12.3666L20.5335 5.83331L22.1668 7.46665L15.6335 14L22.1668 20.5333L20.5335 22.1666L14.0002 15.6333L7.46683 22.1666Z"
      fill="#6b7280"></path>
  </svg>
</div>
